<template>
  <template
    v-if="
      'MyObjects' != route.name ||
      store.state.promocode.errMessages.detail !==
        'Данный промокод не найден. Возможно, он введен неверно или уже не действует.'
    "
  >
    <v-snackbar
      v-if="title == 'Успех'"
      location="bottom right"
      v-model="status"
    >
      <v-alert density="compact" text type="success">
        <div class="success__text">{{ success }}</div>
      </v-alert>
    </v-snackbar>
    <v-snackbar
      v-else-if="title == 'Внимание'"
      location="bottom right"
      v-model="status"
    >
      <v-alert density="compact" text type="warning">
        <div class="warning__text">{{ warning }}</div>
      </v-alert>
    </v-snackbar>

    <v-snackbar v-else type="error" location="bottom right" v-model="status">
      <div>{{ title }}</div>
      <div>
        <div v-for="(error, index) in errors" :key="index">
          {{
            error.field_verbose != null && error.field_verbose != undefined
              ? error.field_verbose + " - "
              : ""
          }}
          {{ error.message }}
        </div>
      </div>
    </v-snackbar>
  </template>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();
const status = ref(false);

let unsubscribe = null;

onMounted(() => {
  unsubscribe = store.subscribe((mutation) => {
    if (mutation.type === "SET_ERROR_NOTIFICATION") {
      status.value = false;
      setTimeout(() => {
        status.value = true;
      }, 100);
    }
    if (mutation.type === "SET_SUCCESS_NOTIFICATION") {
      status.value = false;
      setTimeout(() => {
        status.value = true;
      }, 500);
    }
    if (mutation.type === "SET_WARNING_NOTIFICATION") {
      status.value = false;
      setTimeout(() => {
        status.value = true;
      }, 100);
    }
  });
});

onUnmounted(() => {
  if (unsubscribe) {
    unsubscribe();
  }
});

const title = computed(() => {
  return store.getters.getNotifyTitle;
});

const errors = computed(() => {
  return store.getters.getNotifyErrors;
});

const success = computed(() => {
  return store.getters.getNotifySuccess;
});

const warning = computed(() => {
  return store.getters.getNotifyWarning;
});
</script>

<style scoped>
.success__text {
  color: green;
}
.warning__text {
  color: #fb8c00;
}

:deep(.bg-success) {
  background-color: #fff !important;
}
:deep(.bg-warning) {
  background-color: #fff !important;
}
:deep(.bg-error) {
  background-color: #fff !important;
}
</style>
